export default __webpack_public_path__ + "static/bnr-magazine-efdb9dd5aae8b918f09637d34dd34fff.svg";